export default __webpack_public_path__ + "static/media/12.4daa7210.jpg";